export enum ESize {
  NONE = 'none',
  XXS = 'xxs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = '2xl',
  XXXL = '3xl',
  XXXXL = '4xl',
  XXXXXL = '5xl',
  FULL = 'full',
}

export enum EProcessState {
  Idle = 'IDLE',
  Loading = 'LOADING',
  Completed = 'COMPLETED',
  Error = 'ERROR',
}

export enum EProgressStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  Locked = 'locked',
  Completed = 'completed',
  ComingSoon = 'coming_soon',
}
